import React, { useEffect, useState } from 'react';
import { saske, saske_prof, saskelogo } from '../../../images/images';
import ParticleBackground from "../../common/ParticleBackground.js";
import ClientStory from '../../common/ClientStory.jsx';
import ScrollTextEffect from '../../common/ScrollText.jsx';
import TextSequence from '../../common/TextSequence.jsx';
import ImageScaleSection from '../../common/ImageScale.jsx';
import FlipServices from '../../common/FlipServices.jsx';
import CustomCursor from '../../common/CustomCursor.jsx';
import InfiniteMarquee from '../../common/InfiniteMarquee.jsx';
import TiltCard from '../../common/TiltCard.jsx';
import FallingText from '../../common/FallingText.jsx';
import MobileStackedCards from '../../common/StackedCard.jsx';
import MobileBottomMenu from '../../common/ElasticMenu.jsx';
import PremiumTestimonials from '../../common/Prem.jsx';


function MainscreenAr() {

	const saskeServices=[
		{ id: 1, title: "Facebook", desc: "تواصل معنا الأن عبر بيدج الشركه علي الفيسبوك.", icon: "bi bi-facebook" , link:"https://facebook.com/saskecompany1"},
        { id: 2, title: "whatsapp", desc: "يمكنك التواصل معنا من لمزيد من المعلومات و طلب خدماتنا عبر الواتساب", icon: "bi bi-whatsapp", link:"https://wa.me/01060950140"},
        { id: 3, title: "phone", desc: "تواصل معنا الأن عبر الهاتف علي الرقم 01060950140", icon: "bi bi-phone", link:"tel:+201060950140"}
    ]

	return (
		<>
			<CustomCursor />
			<ParticleBackground />
			<MobileBottomMenu />
			<header>
            	<div className='hero-sec'>
					<center>
						<img id="logoImg" width="90%" src={saskelogo} alt='SASKE Logo'/>
						<h1 style={{ fontSize: '5vw'}}>
							<ScrollTextEffect 
								dletspeed={1/1}
								text="للبرمجيات و خدمات الكمبيوتر" 
								speed={60} // كل ما قل الرقم زادت السرعة
								className="custom-hero-title" // ارفع الحجم أو غير اللون براحتك
								/>
						</h1>
					<h2 style={{padding:"0 1vw"}}>
						<ScrollTextEffect 
							dletspeed={1/1}
							text="Next-Gen Software Engineering & E-Commerce Solutions" 
							speed={80}
							/>
					</h2>
					<div className='magnetic-container'>
						<a href='https://wa.me/01060950140'><button className="magnetic-button">
							احجز استشارتك التقنية مجاناً
						</button></a>
						<a href={saske_prof}>
							<button className="magnetic-button" style={{ border: '1px solid #c084fc' }}>
								تصفح أعمالنا ↗
							</button>
						</a>
					</div>
					</center>
				</div>
			</header>
			 <ImageScaleSection />
			<FlipServices />
			<InfiniteMarquee />
			<FallingText />
			<div>
				<TextSequence />
			</div>
			<ClientStory />
			<MobileStackedCards />
			<PremiumTestimonials />
			<div id='tiltBox'>
				<center id="contact"><h1>للتواصل معنا</h1></center>
				<div className="tilt-section">
					{saskeServices?saskeServices.map((service) => (
						<TiltCard 
							key={service.id} 
							title={service.title} 
							desc={service.desc} 
							icon={service.icon} 
							link={service.link} 
						/>
					)):""}
				</div>
			</div>
		</>
	);
}

export default MainscreenAr;
